import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import {
  IntegrationEnum,
  IntegrationStatus,
  IntegrationType,
} from 'models/InternalIntegrationSetting';

const useShouldRedirectToIntegrationsList = (id: IntegrationEnum) => {
  const { data: integrationAgencySettings, isLoading } =
    useFetchIntegrationAgencySettings({
      enumId: id,
    });

  const isStatusNotAllowed =
    !isLoading &&
    integrationAgencySettings?.agencySettings?.status !==
      IntegrationStatus.ACTIVE;

  const isChannelIntegration =
    !isLoading &&
    integrationAgencySettings?.integration?.type === IntegrationType.CHANNEL;

  const isAllowedOnlyForAgencyLevel =
    !isLoading && integrationAgencySettings?.integration?.allowedForAgencyOnly;

  return (
    isStatusNotAllowed || isChannelIntegration || isAllowedOnlyForAgencyLevel
  );
};

export default useShouldRedirectToIntegrationsList;
